<template>
    <div class="card card-highlighted">
        <div class="card-body">
            <div class="row m-t-40">
                <div class="col b-r text-center">
                    <h3 class="font-light">{{contract.status}}</h3>
                    <h6>State</h6>
                </div>
                <div class="col text-center">
                    <h3 class="font-light" v-if="contract.total">{{contract.total | money }}</h3>
                    <h6>Total Amount</h6>
                </div>
            </div>
        </div>
        <div>
            <hr>
        </div>
        <template>
            <post :contractid="contract.id" v-if="contract.status === 'DRAFT'"></post>
            <confirm :contractid="contract.id" v-if="contract.status === 'POSTED'"></confirm>
            <complete v-if="contract.status === 'CONFIRMED'"></complete>
            <void v-if="contract.status === 'VOID'"></void>
        </template>

        <!--<div class="p-25 border-top m-t-15">-->
        <!--<div class="row text-center">-->
        <!--<div class="col-6 border-right">-->
        <!--<a class="link d-flex align-items-center justify-content-center font-medium" href="#">-->
        <!--<i class=" fas fa-gavel font-15 m-r-5"></i>&nbsp;Dispute-->
        <!--</a>-->
        <!--</div>-->
        <!--<div class="col-6">-->
        <!--<a class="link d-flex align-items-center justify-content-center font-medium" href="#">-->
        <!--<i class="fas fa-times-circle font-15 m-r-5"></i>&nbsp;Cancel-->
        <!--</a>-->
        <!--</div>-->
        <!--</div>-->
        <!--</div>-->
    </div>
</template>

<script>
    import Post from "./slots/Post";
    import Confirm from "./slots/Confirm";
    import Complete from "./slots/Complete";
    import Void from "./slots/Void";

    export default {
        name: "Sidebar",
        components: {Void, Complete, Confirm, Post},
        props: {
            contract: Object
        },
    }
</script>

<style scoped>

</style>
